import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-300" data-mp="2urlqfht25jf">
      <div className="max-w-5xl mx-auto" data-id="element-301" data-mp="2tzoz1ch21rk">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-302" data-mp="2x5daeda0zm8">
          <div data-id="element-303" data-mp="3u2x1373l005v">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-5 text-blue-950 uppercase" data-id="element-304" data-mp="3g9xpvhau0s44">
              See the Grooming Skill Before You Teach It
            </h2>
            <p className="text-xl font-semibold text-blue-950 mb-1" data-id="element-305" data-mp="3l6eai1itoocg">Dog grooming is practical.</p>
            <p className="text-xl font-semibold text-orange-500 mb-5" data-id="element-306" data-mp="36dudlim9nd3g">
              Your teaching material should be practical too.
            </p>
            <p className="text-slate-800 leading-relaxed" data-id="element-307" data-mp="eqiy2649zin8">
              <span className="font-semibold text-blue-950" data-id="element-308" data-mp="9shdthv45da6">Dog Grooming Instructor Ready</span>{' '}
              uses visual resources throughout the complete 6-in-1 system to make complex grooming
              techniques easier for the instructor to explain and easier for the student to
              understand.
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6" data-id="element-309" data-mp="3s79v6t3yxg3o">
            <p className="text-sm font-bold text-blue-600 uppercase tracking-wider mb-4" data-id="element-310" data-mp="3n86q58nzn9vp">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-311" data-mp="4upcjx8kwetb">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-slate-800" data-id="element-312" data-mp="uuey8mg7wc">
                  <CheckCircle2 size={16} className="text-blue-600 shrink-0 mt-0.5" data-id="element-313" data-mp="38gekjodzxa76" />
                  <span data-id="element-314" data-mp="34gnlyyi89ps3">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <p className="text-center text-2xl md:text-4xl font-extrabold tracking-tight text-blue-950 mt-14" data-id="element-315" data-mp="17efb390qt9e3">
          <span className="text-orange-500" data-id="element-316" data-mp="1h62xgvig008p">100% VISUAL.</span> PRACTICAL. READY TO TEACH.
        </p>
      </div>
    </section>;
}